<template>
	<Layout>
		<Sider collapsible v-model="isCollapsed" width="150" :collapsed-width="45" style="text-align: left;">
			<Menu ref="side_menu" :active-name="currentPath" theme="dark" width="auto" :open-names="openNames"
				:class="menuitemClasses">
				<div v-bind:key="itemIndex" v-for="(item, itemIndex) in MenuList">
					<Submenu v-bind:name="itemIndex" v-if="item.children.length > 0">
						<template slot="title">
							<Tooltip :content="$tm(item.name, item.title)" placement="right" theme="dark">
								<svg v-if="item.icon" aria-hidden="true" :class="chooseStyle">
									<use :xlink:href="item.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
								</svg>
							</Tooltip>
							<!-- 菜单窄：显示缩写，鼠标悬停用 title 显示全称 -->
							<span :title="$tm(item.name, item.title)">{{$tms(item.name, item.title)}}</span>
						</template>
						<router-link v-bind:key="itemIndex2" v-for="(item2,itemIndex2) in item.children"
							v-bind:to="item.path+'/'+item2.path">
							<MenuItem v-bind:name="item.path+'/'+item2.path">
								<Tooltip :content="$tm(item2.name, item2.title)" placement="right" theme="dark">
									<svg aria-hidden="true" :class="chooseStyle">
										<use :xlink:href="item2.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
									</svg>
								</Tooltip>
								<span :title="$tm(item2.name, item2.title)">{{$tms(item2.name, item2.title)}}</span>
							</MenuItem>
						</router-link>
					</Submenu>
					<Submenu v-else v-bind:name="itemIndex">
						<template slot="title">
							<Tooltip :content="$tm(item.name, item.title)" placement="right" theme="dark">
								<svg v-if="item.icon" aria-hidden="true" :class="chooseStyle">
									<use :xlink:href="item.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
								</svg>
							</Tooltip>
							<span :title="$tm(item.name, item.title)">{{$tms(item.name, item.title)}}</span>
						</template>
						<router-link v-bind:key="itemIndex" v-bind:to="item.path + item.path + 's'">
							<MenuItem v-bind:name="item.path">
								<Tooltip :content="$tm(item.name, item.title)" placement="right" theme="dark">
									<svg aria-hidden="true" :class="chooseStyle">
										<use :xlink:href="item.icon" fill="#b5c1c3" style="color:#b5c1c3 ;"></use>
									</svg>
								</Tooltip>
								<span :title="$tm(item.name, item.title)">{{$tms(item.name, item.title)}}</span>
							</MenuItem>
						</router-link>
					</Submenu>
				</div>
			</Menu>
		</Sider>
		<Layout :style="{padding: '0 10px',height:'100%'}">
			<Content :style="{padding: '0px',background: '#F1F4F5'}">
				<MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread>
				<keep-alive>
					<router-view :key="viewKey"></router-view>
				</keep-alive>
			</Content>
		</Layout>
	</Layout>
</template>

<script>
	import {
		mapState,
	} from 'vuex'
	import {
		langState
	} from '../../../language'
	export default {
		//props:['MenuList'],
		data() {
			return {
				MenuList: [],
				Menu: [],
				isCollapsed: false,
				openNames: [0],
				activeName: "0-0",
				BreadcrumbList: [],
			};
		},
		computed: {
			//路由出口 key：路径 + 语言版本，切换语言时重建页面
			viewKey() {
				return this.$route.fullPath + '|' + langState.version
			},
			//直接选属性
			currentPath: function() {
				// 注：这里每次路由变化都会重新计算，不要加 console.log，会影响切换菜单的响应速度
				return '/' + this.$route.path.split('/')[1] + '/' + this.$route.path.split('/')[2]
			},
			//直接选属性
			...mapState({
				silderMethod: 'silderMethod',
			}),
			menuitemClasses: function() {
				return [
					'menu-item',
					this.isCollapsed ? 'collapsed-menu' : ''
				]
			},
			chooseStyle: function() {
				const _this = this;
				if (_this.isCollapsed) {
					return "icon closeStyle"
				} else {
					return "icon openStyle"
				}
			}
		},
		//监听地址栏变化，菜单变动
		watch: {
			$route(to, from) {
				const path = to.path.split('/');
				this.getSiderMenus(path);
			},
			activeName() {
				this.$nextTick(() => {
					this.$refs.side_menu.updateOpened();
					this.$refs.side_menu.updateActiveName();
				})
			}
		},
		//首次加载不触发 watch 挂载时主动查发一次
		created: function() {
			this.Menu = this.$store.state.silderMethod
			const path = this.$route.path.split('/');
			this.getSiderMenus(path);
		},
		methods: {
			getSiderMenus(path) {
				console.log("菜单变动");
				this.MenuList = [];
				let topName = '';
				this.BreadcrumbList = [];
				for (let i = 0; i < this.Menu.length; i++) {
					if (this.Menu[i].path == "/" + path[1]) {
						topName = this.Menu[i].topName;
						// this.MenuList.push(this.Menu[i]);
						// key 用后端返回的 name / topName 做映射，text 为后端原文
						this.BreadcrumbList.push({
							key: topName,
							text: topName
						});
						this.BreadcrumbList.push({
							key: this.Menu[i].name,
							text: this.Menu[i].title
						});
					}
				}
				for (let i = 0; i < this.Menu.length; i++) {
					if (this.Menu[i].topName == topName) {
						this.MenuList.push(this.Menu[i]);
						for (let c = 0; c < this.Menu[i].children.length; c++) {
							if (this.Menu[i].children[c].path == path[2]) {
								this.BreadcrumbList.push({
									key: this.Menu[i].children[c].name,
									text: this.Menu[i].children[c].title
								});
							}
						}
					}
				}
				if (!this.MenuList || this.MenuList.length < 1) return;
				this.openNames = this.MenuList.map((obj, index) => index);
				this.activeName = this.MenuList[0].path + "/" + this.MenuList[0].children[0].path;
				// this.BreadcrumbList = [this.MenuList[0].title, this.MenuList[0].children[0].title];
				console.log(this.activeName, this.openNames);
				console.log("菜单变动结束");
			},
		}
	}
</script>

<style>
	.layout-con {
		height: 100%;
		width: 100%;
	}

	.menu-item span {
		display: inline-block;
		overflow: hidden;
		/* width: 80px; */
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: bottom;
		transition: width 0.2s ease 0.2s;
	}

	.menu-item i {
		transform: translateX(0px);
		transition: font-size 0.2s ease, transform 0.2s ease;
		vertical-align: middle;
		font-size: 1.25rem;
	}

	.collapsed-menu span {
		width: 0px !important;
		transition: width 0.2s ease;
	}

	.collapsed-menu .ivu-menu-item {
		padding: 14px 9px !important;
	}

	.collapsed-menu i {
		transform: translateX(5px);
		transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
		vertical-align: middle;
		font-size: 1.25rem;
	}

	.ant-layout-sider-trigger {
		display: block !important;
	}
	
	:deep(.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened) {
		background: #303078aa !important;
	}

	.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
		content: "";
		display: block;
		width: 2px;
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		background: #3098ff;
	}

	.closeStyle {
		width: 18px;
		height: 18px;
		vertical-align: middle;
	}

	.openStyle {
		width: 18px;
		height: 18px;
		vertical-align: middle;
		margin-right: 5px;
	}
	
	.ivu-layout-sider-collapsed .ivu-menu-submenu-title-icon {
		display: none;
	}

	.menu-item span {
		/* 菜单限宽：缩写仍放不下时省略号截断，完整名称由 title 悬停显示 */
		display: inline-block;
		max-width: 90px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: middle;
	}
	
	.ivu-layout-sider-trigger i::before {
		content: "";
		white-space: pre;
	}
	
	.ivu-layout-sider-trigger-collapsed i::before {
		content: '';
	}
	
	.ivu-layout-sider-collapsed .ivu-menu-vertical .ivu-menu-submenu-title {
		padding: 14px 20px;
	}
	
	.ivu-menu-vertical .ivu-menu-submenu-title-icon {
		right: 0 !important;
	}
	
	.ivu-menu-vertical .ivu-menu-submenu-title {
		padding: 14px 14px !important;
	}
	
	.ivu-menu-submenu-title {
		height: 45px;
	}
	.ivu-menu-submenu .ivu-menu-item {
		display: inline-flex;
		padding-left: 30px !important;
	}
	.collapsed-menu .ivu-menu-submenu .ivu-menu-item {
		display: inline-flex;
		padding-left: 15px !important;
	}
	
	.ivu-menu .ivu-tooltip-popper {
		left: 45px !important;
	}
</style>